import React from 'react';
import FormField from './FormField';

interface TesterNameFieldProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
}

const TesterNameField: React.FC<TesterNameFieldProps> = ({
  value,
  onChange,
  onBlur,
  error,
  disabled = false,
}) => {
  return (
    <div className="tester-name-section">
      <FormField
        label="Tester Name"
        name="tester_name"
        type="text"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required
        placeholder="Enter your name"
        error={error}
        minLength={2}
        maxLength={100}
        disabled={disabled}
      />
    </div>
  );
};

export default TesterNameField;




